import { TOKEN_KEY } from 'src/constants';

export function SaveUser(tokenType, accessToken, refreshToken) {
  if (!tokenType || !accessToken) return false;

  try {
    localStorage.setItem(TOKEN_KEY.TOKEN_TYPE, tokenType);
    localStorage.setItem(TOKEN_KEY.ACCESS_TOKEN, accessToken);
    if (refreshToken) {
      localStorage.setItem(TOKEN_KEY.REFRESH_TOKEN, refreshToken);
    }
  } catch {
    return false;
  }

  return true;
}

export function GetAuthorization() {
  let tokenType = '';
  let accessToken = '';
  try {
    tokenType = localStorage.getItem(TOKEN_KEY.TOKEN_TYPE);
    accessToken = localStorage.getItem(TOKEN_KEY.ACCESS_TOKEN);
    if (!tokenType || !accessToken) return '';
  } catch {
    return false;
  }

  return `${tokenType} ${accessToken}`;
}

export function ClearLocalStorage() {
  try {
    localStorage.clear();
  } catch {
    return false;
  }

  return true;
}

export function GetAccessToken() {
  let accessToken = '';
  try {
    // FIXME resolve the 3rd-party onboarding problem
    let m = window.location.href.match(/token1=([a-zA-Z0-9]*)/);
    if (m) {
      localStorage.setItem(TOKEN_KEY.TOKEN_TYPE, 'Bearer');
      localStorage.setItem(TOKEN_KEY.ACCESS_TOKEN, m[1]);
    }

    accessToken = localStorage.getItem(TOKEN_KEY.ACCESS_TOKEN);
    if (!accessToken) return '';
  } catch {
    return '';
  }

  return accessToken;
}

export function SaveCardPaymentStatus(acceptCardPayments, onboardStatus) {
  if(!acceptCardPayments) return false;

  try {
    localStorage.setItem(TOKEN_KEY.ACCEPT_CARD_PAYMENTS, acceptCardPayments);
    localStorage.setItem(TOKEN_KEY.STRIPE_ONBOARD_STATUS, onboardStatus);
  } catch {
    return false;
  }

  return true;
}

export function GetCardPaymentStatus() {
  let acceptCardPayments = false;
  let onboardStatus = '';

  try {
    acceptCardPayments = localStorage.getItem(TOKEN_KEY.ACCEPT_CARD_PAYMENTS);
    onboardStatus = localStorage.getItem(TOKEN_KEY.STRIPE_ONBOARD_STATUS);
  } catch {}

  return { acceptCardPayments, onboardStatus };
}
